import { DEPRECATED_TIMEZONE_MAP, DeprecatedTimezone } from 'util/Date/timezones';
import { WeekDay, WeekDayMap } from './models';
import { DateTime } from 'luxon';

export const getValidTimezone = (timezone: DeprecatedTimezone | string) => DEPRECATED_TIMEZONE_MAP[timezone as DeprecatedTimezone] || timezone;

export function getWeekDay(timezone?: string, date: Date = new Date(Date.now())) {
  if (isNaN(date.valueOf())) {
    if (process.env.NODE_ENV === 'development') throw new Error('Invalid baseDate provided to getWeekDay');
    console.error('Invalid baseDate provided to getWeekDay. Falling back to local time.');
    date = new Date(Date.now()); // graceful fallback for prod.
  }

  if (timezone) {
    const { weekdayLong } = DateTime.fromJSDate(date, { zone: getValidTimezone(timezone) });

    return weekdayLong !== undefined ? weekdayLong.toLowerCase() : console.error('Weekday returned from luxon as undefined.'); // reverse enum lookup
  }

  return WeekDayMap[date.getDay()] as WeekDay;
}

export const isFutureDate = (date: string, timezone: string) => {
  const daysDiff = DateTime.local({ zone: timezone })
    .diff(DateTime.fromMillis(parseInt(date), { zone: timezone }), ['days'])
    .toObject()
    .days?.toFixed();
  if (daysDiff && parseInt(daysDiff) < 0) return true;

  return false;
};
